/* eslint-disable no-nested-ternary */
/* eslint-disable no-alert */
import React from "react";

import { makeStyles } from "@material-ui/core/styles";
import { CircularProgress } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  loading: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: 300,
    maxWidth: "100%",
    width: "100%",
  },
}));

export default function TabsLoading({ data }) {
  const classes = useStyles();

  return (
    <div className={classes.loading}>
      <CircularProgress
        style={{
          width: 70,
          height: 70,
        }}
        disableShrink
      />
    </div>
  );
}
